import React from 'react';
import { Col, Menu, Icon, Row } from 'antd';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import experimentIcon from './experiment-icon.png';

import './index.css'

const { SubMenu, Item } = Menu;

class Sidebar extends React.Component {
	render() {

		const pathArray = this.props.location.pathname.split('/');

		const openKeys = [`/${pathArray[1]}`];

		const selected = [`/${pathArray[1]}`, this.props.location.pathname];

		const { ezSuperuser, user } = this.props;
		const { ezBoss } = this.props.user.data.permissions;

		return (
			<Menu
				className="sidebar"
				onClick={this.handleClick}
				selectedKeys={selected}
				// defaultOpenKeys={openKeys}
				openKeys={this.state.openKeys}
				onOpenChange={this.onOpenChange}
				theme="dark"
				mode="inline">

				{/* Dashboard */}
				{/* <Item key="/dashboard" >
					<Icon type="pie-chart" />
						<span>Dashboard</span>
				</Item> */}
				<Item>
					<a target="iso-27001" href="https://api.eezee.sg/api/auth-rp/eezee-iso-27001-2022">
						<Row type="flex" justify="space-between" align="top">
							<Col>
								<Icon type="safety" /> ISO 27001
							</Col>
							<Col>
								<span className="eezee-sidebar-alert-badge">NEW</span>
							</Col>
						</Row>
					</a>
				</Item>

				{/* Eezee Site Menu */}
				<SubMenu key="/eezee-site-menu" title={<span><Icon type="star" />Eezee Site</span>}>

					{/* Ads */}
					<Item key="/eezee-ads">Ads</Item>

					{/* Banners */}
					<Item key="/homepage/banners">Banners</Item>

					{/* Category Feature Page */}
					<Item key="/category-feature">Category Feature</Item>

					{/* Docs */}
					<Item key="/docs" >Documentation</Item>

					{/* Featured */}
					<Item key="/homepage/featured">Featured</Item>

					{/* Leaf Page */}
					<Item key="/leaf-pages">Leaf Pages</Item>

				</SubMenu>


				{/* Data Menu */}
				<SubMenu key="/data-menu" title={<span><Icon type="database" />Data</span>}>
					{/* Data Reports Page */}
					<SubMenu
						key="/data-report"
						title={'Data Reports'}
					>
						<Item key="/data-reports">Reports</Item>
						<Item key="/data-reports-history">History</Item>
					</SubMenu>

					<Item key="/data" >Data</Item>

				</SubMenu>


				{/* Finance Menu */}
				<SubMenu key="/finance-menu" title={<span><Icon type="pay-circle" />Finance</span>}>

					{/* Finance */}
					<SubMenu
						key="/fin"
						title={'Finance'}>
						<Item key="/finance/notifications">Notifications</Item>
						<Item key="/finance/supplier-soa">Supplier SOA</Item>
						<Item key="/finance/payment-advice">Payment Advice</Item>
						<Item key="/finance/credit-note">Credit Note</Item>
						<Item key="/finance/refunds">Refunds</Item>
					</SubMenu>

					{/* Credit */}
					<SubMenu
						key="/credit"
						title={'Credit'}>
						<Item key="/credit-approval">Approval</Item>
						<Item key="/credit-overview">Overview</Item>
						<Item key="/credit-payment">Payment</Item>
					</SubMenu>

				</SubMenu>


				{/* Operations Menu */}
				<SubMenu key="/ops-menu" title={<span><Icon type="shopping-cart" />Operations</span>}>
					{/* Orders */}
					<Item key="/orders" >Orders</Item>

					{/* Delivery */}
					<SubMenu
						key="/delivery"
						title='Delivery'>
						<Item key="/delivery/scheduler">Scheduler</Item>
						<Item key="/delivery/routes">Chart</Item>
					</SubMenu>

					{/* Quotation */}
					<Item key="/quotation">Quotation</Item>

					{/* SLA Discrepencies */}
					{/* <SubMenu
						key="/sla"
						title='SLA Discrep'>
						<Item key="/sla">Discreps</Item>
						<Item key="/sla/new">New</Item>
					</SubMenu> */}

				</SubMenu>


				{/* Products Menu */}
				<SubMenu key="/product-menu" title={<span><Icon type="gift" />Products</span>}>

					{/* Uploading */}
					<SubMenu
						key="/uploading"
						title='Uploading'>
						<Item key="/products/dashboard">Dashboard</Item>
						<Item key="/products/transfer">Mass Transfer</Item>
						<Item key="/products/mass-duplicate">Mass Duplicate</Item>
						<Item key="/products/synonyms">Synonyms</Item>
						<Item key="/products/changes">Changes</Item>
					</SubMenu>

					{/* Brands */}
					<Item key="/brands" >Brands</Item>

					{/* Category */}
					<Item key="/category" >Category</Item>


				</SubMenu>


				{/* User Menu */}
				<SubMenu key="/user-menu" title={<span><Icon type="smile-o" />Users</span>}>
					<Item key="/users" ><span>Users</span></Item>
					{/* Supplier */}
					<Item key="/supplier" >Supplier</Item>
					{(user.data.permissions.ezSuperuser || user.data.permissions.ezBoss) && (
						<Item key="/admins" ><span>Admins</span></Item>
					)}
				</SubMenu>

				{/* Tech Menu */}
				<SubMenu key="/tech-menu" title={<span><Icon type="laptop" />Tech</span>}>
					<Item key="/tech/stock-integration" ><span>Stock Integration</span></Item>
					{/**
					 * Removed Bugs page
					 * Bugs reporting done on clickup
					 * Service Requests will be deprecated, 
					 * all client contact to ops will be through freshchat
					 */}
					{/* Bugs */}
					{/* <Item key="/bugs" >Bugs</Item> */}
				</SubMenu>


				{/* Enterprise */}
				<SubMenu
					key="/enterprise"
					title={<span><Icon type="team" />Enterprise</span>}
				>
					<Item key="/enterprise/dashboard">Dashboard</Item>
					<Item key="/enterprise/contracts">Contracts</Item>
					<Item key="/enterprise/term-contracts">Term Contracts</Item>
					<Item key="/supplier/price-lists">Supplier Price Lists</Item>
				</SubMenu>

				{/* VM Menu */}
				<SubMenu key="/vm-menu" title={<span><Icon type="barcode" />IOT</span>}>
					{/* Rfid Tag Product */}
					<Item key="/rfid-tag-product" ><span>Tag Products for VM</span></Item>

					{/* Vm Page */}
					<Item key="/vm" ><span>VM Manager</span></Item>

					{/* Vm supplier Page */}
					<Item key="/vm-supplier" ><span>VM Supplier</span></Item>
				</SubMenu>

			</Menu >

		)

	}

	constructor(props) {
		super(props);

		this.state = {
			current: "nav1",
			openKeys: [],
			rootSubmenuKeys: ['/eezee-site-menu', '/data-menu', '/finance-menu', '/ops-menu', '/product-menu', '/user-menu', '/enterprise', '/bugs']
		}

		this.handleClick = this.handleClick.bind(this);
		// this.handleOpen = this.handleOpen.bind(this);
	}

	handleClick(evt) {

		this.props.history.push(evt.key);
		// this.setState({
		// 	current: evt.target.key
		// })
	}

	onOpenChange = (openKeys) => {
		const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
		if (this.state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
			this.setState({ openKeys });
		} else {
			this.setState({
				openKeys: latestOpenKey ? [latestOpenKey] : [],
			});
		}
	};

}

export default
	withRouter(
		connect(
			state => ({
				user: state.user
			})
		)(Sidebar)
	);



// WEBPACK FOOTER //
// ./src/components/sidebar/index.js